import { z } from 'zod'
import type { AuditLogEntry } from '#/domain/audit/AuditLogEntry'
import type { AuditLogPage } from '#/domain/audit/AuditLogRepository'
import type {
  AuditLogDto as AuditLogDtoSpec,
  PagedResultDtoOfAuditLogDto as PagedResultDtoOfAuditLogDtoSpec,
} from '#/infrastructure/api/generated'
import type { Assert, SpecContract } from '#/infrastructure/api/SpecContract'

export const AuditLogDtoSchema = z
  .object({
    Id: z.string(),
    SchemaVersion: z.number(),
    AuthorEmail: z.string(),
    TableName: z.string(),
    RecordId: z.string(),
    Action: z.string(),
    OldData: z.unknown().nullish(),
    NewData: z.unknown().nullish(),
    IpAddress: z.string().nullish(),
    Browser: z.string().nullish(),
    OrganizationId: z.string().nullish(),
    ApplicationId: z.string().nullish(),
    InsertedTimestamp: z.string(),
  })
  .transform((raw): AuditLogEntry => ({
    Id: raw.Id,
    SchemaVersion: raw.SchemaVersion,
    AuthorEmail: raw.AuthorEmail,
    TableName: raw.TableName,
    RecordId: raw.RecordId,
    Action: raw.Action,
    OldData: raw.OldData,
    NewData: raw.NewData,
    IpAddress: raw.IpAddress ?? undefined,
    Browser: raw.Browser ?? undefined,
    OrganizationId: raw.OrganizationId ?? undefined,
    ApplicationId: raw.ApplicationId ?? undefined,
    InsertedTimestamp: raw.InsertedTimestamp,
  }))

export type AuditLogResponseDto = z.input<typeof AuditLogDtoSchema>
export type AuditLogDtoSpecContract = Assert<SpecContract<AuditLogResponseDto, AuditLogDtoSpec>>

const AuditLogPageDtoSchema = z
  .object({
    Items: z.array(AuditLogDtoSchema),
    Total: z.number(),
  })
  .transform((raw): AuditLogPage => ({
    items: raw.Items,
    total: raw.Total,
  }))

export type AuditLogPageResponseDto = z.input<typeof AuditLogPageDtoSchema>
export type AuditLogPageDtoSpecContract = Assert<
  SpecContract<AuditLogPageResponseDto, PagedResultDtoOfAuditLogDtoSpec>
>

export function toDomainPage(raw: AuditLogPageResponseDto): AuditLogPage {
  return AuditLogPageDtoSchema.parse(raw)
}
